module.exports = __webpack_public_path__ + "static/media/2-Plug-in-to-Power.ce80a4bf.svg";